"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.publish = void 0;
const sns = __importStar(require("@aws-sdk/client-sns"));
const events = __importStar(require("./index"));
const utils_1 = require("../utils");
/**
 * Publishes a message to the SNS topic which is the event driver for all inter-service message subscriptions.
 * Each event must have a `Domain` and `Name` attribute sent. This is to enable event subscribers to be able to filter
 * out events by domain or specific type.
 *
 * @param event
 * @param successHandler()
 * @param errorHandler()
 * @param fifo Whether to publish to the first in first out (fifo) topic or not.
 * @param options
 */
const publish = (event, successHandler, errorHandler, fifo = true, options) => __awaiter(void 0, void 0, void 0, function* () {
    new sns.SNSClient({ region: events.config.region })
        .send(new sns.PublishCommand({
        TopicArn: fifo
            ? events.config.publishFifoTopicArn
            : events.config.publishTopicArn,
        MessageGroupId: (options === null || options === void 0 ? void 0 : options.messageGroupId) || events.config.messageGroupId || (0, utils_1.getUniqueString)(16),
        MessageDeduplicationId: (0, utils_1.getUniqueString)(16),
        MessageAttributes: {
            Domain: {
                DataType: 'String',
                StringValue: event.domain,
            },
            Name: {
                DataType: 'String',
                StringValue: event.name,
            },
        },
        Message: JSON.stringify(event.data),
    }))
        .then((data) => successHandler(data.MessageId))
        .catch((err) => errorHandler(err));
});
exports.publish = publish;
